<script setup lang="ts">
</script>

<template>
  <div class="absolute top-0 left-0 h-full w-full z-20 animate-pulse blur-sm cursor-wait space-y-1 bg-white">
    <div v-for="i in 6" :key="i" class="border-b border-gray-100 py-4 last:border-b-0">
      <div class="flex justify-between items-center">
        <div class="flex gap-2 items-center w-3/4">
          <div class="h-4 bg-gray-200 rounded w-1/3"></div>
          <div class="h-4 bg-gray-100 rounded w-1/2"></div>
        </div>
        <div class="h-4 bg-gray-100 rounded w-4"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
